<template>
    <wrapper-edit
            wTitle="订单详情页面"
        :wrapper-width="wrapperWidth"
        @back="paasPageBack('', serviceUrl+'/list?sysEnumGroupCode='+paasFormData.sysEnumGroupCode)"  class="enum-table">
     <div slot="form">
         <Widget
                 title="订单信息"
                 icon="iconfont iconwenzhangguanli1"
                 widgeType="simple"
                 titleColor="#2766f6">
             <div slot="toolbar"></div>
             <div slot="content" class="order-content">
                <table class="orderDescTable">
                    <tr>
                        <th>订单号</th>
                        <td>{{paasFormData.orderCode}}</td>
                        <th>订单状态</th>
                        <td>
                            <EnumShow
                                    enum-group-code="crmdict"
                                    enum-code="orderStatus"
                                    :value="paasFormData.status">
                            </EnumShow>
                        </td>
                    </tr>
                    <tr>
                        <th>下单时间</th>
                        <td>{{paasFormData.orderTime}}</td>
                        <th>支付时间</th>
                        <td>{{paasFormData.payTime}}</td>
                    </tr>
                    <tr>
                        <th>支付方式</th>
                        <td>
                            <EnumShow
                                    :enum-group-code="'crmdict'"
                                    :enum-code="'payType'"
                                    :value="paasFormData.payType">
                            </EnumShow>
                        </td>
                        <th>用户昵称</th>
                        <td>{{paasFormData.buyer}}</td>
                    </tr>
                    <tr>
                        <th>收货人</th>
                        <td>{{paasFormData.realName}}</td>
                        <th>地址</th>
                        <td>{{paasFormData.userAddress}}</td>
                    </tr>
                    <tr>
                        <th>手机</th>
                        <td>{{paasFormData.userPhone}}</td>
                        <th>快递单号</th>
                        <td>
                            <Button type="text" @click="checkExpressInfo">
                                {{paasFormData.expressNumber}}<span class="checkFlag">查询物流信息</span>
                            </Button>
                        </td>
                    </tr>
                    <tr>
                        <th>总金额</th>
                        <td>{{paasFormData.totalPrice}}</td>
                        <th>实付款</th>
                        <td>{{paasFormData.payPrice}}</td>
                    </tr>
                    <tr>
                        <th>优惠券金额</th>
                        <td>{{paasFormData.couponPrice}}</td>
                        <th>积分抵扣金额</th>
                        <td>{{paasFormData.integralDeduct}}</td>
                    </tr>
                </table>
             </div>
         </Widget>
         <Widget
                 title="商品信息"
                 icon="iconfont iconwenzhangguanli1"
                 widgeType="simple"
                 titleColor="#2766f6">
             <div slot="toolbar"></div>
             <div slot="content" class="product-content">
                 <table class="produtTable">
                     <thead>
                        <tr>
                            <th>操作</th>
                            <th>MC订单号</th>
                            <th>货号</th>
                            <th>SKU</th>
                            <th>商品名称</th>
                            <th>颜色尺码</th>
                            <th>数量</th>
                            <th>应付金额</th>
                            <th>实付金额</th>
                            <th>优惠券抵扣</th>
                            <th>积分抵扣</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr v-for="(item,index) in orderProducts" :key="index">
                            <td>
                                <EnumShow
                                        :enum-group-code="'crmdict'"
                                        :enum-code="'aftersaleType'"
                                        :value="paasFormData.afterSaleStatus" v-if="paasFormData.afterSaleStatus">
                                </EnumShow>
                                <p v-else>暂无售后</p>
                            </td>
                            <td>{{item.infactOrderCode}}</td>
                            <td>{{item.productNo}}</td>
                            <td>{{item.sku}}</td>
                            <td>{{item.name}}</td>
                            <td>{{item.productAttr}}</td>
                            <td>{{item.purchaseNum}}</td>
                            <td>{{item.needPaymentAmount}}</td>
                            <td>{{item.truePaymentAmount}}</td>
                            <td>{{item.couponAmount}}</td>
                            <td>{{item.integralDeduct}}</td>
                        </tr>
                     </tbody>
                 </table>
             </div>
         </Widget>
         <Modal v-model="expressModal" title="订单物流详情">
             <Widget
                     title="物流信息"
                     icon="iconfont iconwenzhangguanli1"
                     widgeType="simple"
                     titleColor="#2766f6">
                 <div slot="toolbar"></div>
                 <div slot="content" class="express-info">
                     <div class="shipping_order" v-if="isSender === false ">
                         卖家暂未发货，请点击按钮更新物流信息
                     </div>
                     <div class="shipping_order" v-if="isSender === true ">
                         <Collapse accordion v-for="(item,index) in expressList" :key="`${item.id}`+index">
                             <Panel name="1">
                                 卖家于{{deliveryTime}}发货,{{deliveryName}}({{deliveryId}})
                                 <p slot="content" v-if="expressList.length > 0">
                                     <Steps :current="0" direction="vertical" status="wait" >
                                         <Step title="" :content="item.status" v-for="(item,key) in expressList" :key="`express`+key"></Step>
                                     </Steps>
                                 </p>
                                 <p slot="content" v-else>
                                     查询无结果，请隔段时间再查
                                 </p>
                             </Panel>
                         </Collapse>
                     </div>
                 </div>
             </Widget>
             <div slot="footer">
                 <Button type="info" size="large" long  @click="expressModal = false">确认</Button>
             </div>
         </Modal>
     </div>
    </wrapper-edit>


</template>

<script>
    import wrapperEdit from '@components/paas/wrapper-edit';
    import metaDetail from '@assets/js/meta-detail.js'
    import Widget from '@components/paas/widget';
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    import {viewLogical} from "@api/store.js";
    export default {
        name: "orderDesc",
        mixins:[metaDetail],
        components:{wrapperEdit,Widget,EnumShow},
        created() {},
        data(){
            return{
                serviceUrl:"/eb/order",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                paasFormData:{
                    id:"",
                    orderCode:"",
                    status:"",
                    orderTime:"",
                    payTime:"",
                    payType:"",
                    buyer:"",
                    realName:"",
                    userAddress:"",
                    userPhone:"",
                    expressNumber:""
                },
                orderProducts:[],
                expressModal:false,
                isSender:false, //是否发货
                expressList:[],
            }
        },
        methods:{
            createdCallback(data) {
                this.orderProducts = data.entity.orderProductList;
            },
            checkExpressInfo(){
                this.expressModal = true;
                //查询物流信息
                viewLogical(this.paasFormData.orderCode).then(res=>{
                    this.expressList = res.data;
                })
            },
        }

    }
</script>

<style scoped>
    .order-content{
        background-color: #ffffff;
    }
    .product-content{
        background-color: #ffffff;
        overflow: scroll;
    }
    table.orderDescTable,table.produtTable{
        width:100%;
        display: table;
        box-sizing: border-box;
        border-collapse: collapse;
        border-spacing: 0;
        border: 1px #E4E7F0 solid;
    }
    table.orderDescTable tr,table.produtTable tr{
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
    }
    table.orderDescTable tr:nth-of-type{
        background: #FAFAFA;
    }
    table.orderDescTable tr:nth-of-type(odd) {
        background: #FAFAFA;
    }
    table.orderDescTable tr th,table.orderDescTable tr td,table.produtTable tr th,table.produtTable tr td{
        height: 32px;
        line-height: 32px;
        border: 1px #E4E7F0 solid;
        padding: 0 8px;
        color: #2C303E;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 500px;
    }
    table.orderDescTable tr th{
        width:200px;
        text-align:right;
    }
    table.orderDescTable tr td{
        text-align:left;
    }
    table.orderDescTable tr:nth-child(2n-1) th:nth-child(2n-1){
        background: #F0F4F7;
    }
    table.orderDescTable tr th:nth-child(1) {
        background: #F5F9FC;
    }
    table.orderDescTable tr th:nth-child(3) {
        background: #F5F9FC;
    }
    .checkFlag{
        color:#2d8cf0;
    }
</style>